/**
 * El clic derecho y el arrastre sobre las fotos del sitio.
 *
 * La protección de verdad es otra: nginx no sirve una foto de producto sin sesión, así que una
 * dirección copiada no anda afuera. Esto es para quien sí entró, que con el menú del clic
 * derecho se llevaba la foto en dos clics. Quien sabe abrir las herramientas del navegador se la
 * lleva igual; no es un candado, es no dejar la puerta abierta.
 *
 * Sólo sobre las fotos. El clic derecho sobre un texto sigue andando: copiar un código de pieza
 * es para lo que más se usa.
 */
export function noCopiarFotos(documento: Document): () => void {
  function frenar(evento: Event) {
    if (evento.target instanceof Element && evento.target.tagName === 'IMG') {
      evento.preventDefault();
    }
  }

  documento.addEventListener('contextmenu', frenar);
  documento.addEventListener('dragstart', frenar);

  return () => {
    documento.removeEventListener('contextmenu', frenar);
    documento.removeEventListener('dragstart', frenar);
  };
}
